export enum FinancialStatus {
  Voided = -3,
  Refunded = -2,
  PartiallyRefunded = -1,
  Pending = 0,
  Authorized = 1,
  PartiallyPaid = 2,
  Paid = 3
}